import { RecordingEntity } from "../models/recording";
import { RecordingViewModel } from "../models/recordingViewModel";

// TODO: Replace with proper mapped fields once BE provides cleaned structure
export const mapRecordingEntityToViewModel = (
  r: RecordingEntity
): RecordingViewModel => ({
  ...r,
  rawEventInfo: r.rawEventInfo,
  id: r.id,
  timestamp: r.ddbRecord.sk?.split("#R#")[1] ?? "",
  modelId: r.ddbRecord.GSIPK2?.split("#R#")[1] ?? "",
  facilityId: r.ddbRecord.GSIPK4?.split("#L#")[1] ?? "",
  keyFrame: r.keyFrame,
  mediaOutput: r.mediaOutput,
  groupId: r.ddbRecord.GSIPK5,
});
